import { createMethod } from "./tools";
import { gtApiWrapper, gtClient, gtPublic } from "./gt-client";

export const api = {
  gt: createMethod(gtClient, gtApiWrapper),
  public: createMethod(gtPublic, gtApiWrapper),
};
